import script from "./TaxDecPicker.vue?vue&type=script&setup=true&lang=js"
export * from "./TaxDecPicker.vue?vue&type=script&setup=true&lang=js"

import "./TaxDecPicker.vue?vue&type=style&index=0&id=065d23c2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-065d23c2"]])

export default __exports__